export default __webpack_public_path__ + "static/media/city.fb5cadd5.jpg";